import "./polyfills";
// import { setStoreValue, subscribe } from "@bd-stores";
import "../classic/sidemenu";
import "../classic/selectbox";
import "../classic/building";
import "../classic/screensaver";
import "../classic/slider";
import "../classic/button";
import * as Pages from "@bd-pages";

Object.keys(Pages).forEach((key) => Pages[key]());
